import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { feedbackService } from "@project/services/admin/feedback.service";
import {
  FEEDBACK_TYPE_OPTIONS,
  type FeedbackAdminPayload,
  type FeedbackRecord,
  type FeedbackType,
} from "@project/types/feedback";

const typeOptions = FEEDBACK_TYPE_OPTIONS.map(o => ({
  value: o.value,
  label: o.label,
}));

const fields: Field[] = [
  { name: "full_name", label: "Name", required: true, showInTable: true },
  { name: "mobile", label: "Mobile", type: "tel", showInTable: true },
  { name: "email", label: "Email", type: "email", hideInTable: true },
  {
    name: "feedback_type",
    label: "Type",
    type: "select",
    options: typeOptions,
    required: true,
    showInTable: true,
  },
  {
    name: "rating",
    label: "Rating",
    type: "rating",
    required: true,
    showInTable: true,
  },
  {
    name: "message",
    label: "Message",
    type: "textarea",
    required: true,
    hideInTable: true,
  },
  {
    name: "order_by",
    label: "Order By",
    type: "number",
    showInTable: true,
    placeholder: "0",
  },
  {
    name: "is_enabled",
    label: "Active",
    type: "boolean",
    showInTable: true,
  },
];

function toPayload(payload: Record<string, unknown>): FeedbackAdminPayload {
  return {
    full_name: String(payload.full_name ?? "").trim(),
    mobile: payload.mobile ? String(payload.mobile).trim() : undefined,
    email: payload.email ? String(payload.email).trim() : undefined,
    feedback_type: String(
      payload.feedback_type ?? "Suggestion"
    ) as FeedbackType,
    rating: Number(payload.rating ?? 1),
    message: String(payload.message ?? "").trim(),
    is_enabled: payload.is_enabled === true || payload.is_enabled === "true",
    order_by:
      payload.order_by !== undefined && payload.order_by !== ""
        ? Number(payload.order_by)
        : 0,
  };
}

export default function Page() {
  return (
    <AdminShell title="Feedback" subtitle="Visitor feedback inbox">
      <ApiResourceTable<FeedbackRecord>
        title="Feedback"
        labelField="full_name"
        fields={fields}
        searchFields={["full_name", "mobile", "feedback_type"]}
        defaultValues={{
          feedback_type: "Suggestion",
          rating: 1,
          is_enabled: false,
          order_by: 0,
        }}
        enableCsvExport
        csvFileName="feedback"
        editOnlyFields={["order_by", "is_enabled"]}
        list={query => feedbackService.listFeedbacksPage(query)}
        create={payload => feedbackService.create(toPayload(payload))}
        update={(id, payload) =>
          feedbackService.update(id, {
            is_enabled:
              payload.is_enabled === true || payload.is_enabled === "true",
            order_by:
              payload.order_by !== undefined && payload.order_by !== ""
                ? Number(payload.order_by)
                : 0,
          })
        }
        remove={id => feedbackService.delete(id)}
      />
    </AdminShell>
  );
}
